// react
import { combineReducers } from 'redux';
import { PageTypeEnum } from 'reducers/sharedata/types';
import { LOADING, ANNOUNCEMENTS, PAGE_TYPE, RESET_KEY, } from './types';
// action
// import resultTableContentData from 'view/AccessManage/M1005/ResultTableContentData.json'
var loading = function (state, action) {
    if (state === void 0) { state = 0; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case LOADING:
            return state + payload;
        default:
            return state;
    }
};
var pageType = function (state, action) {
    if (state === void 0) { state = PageTypeEnum.home; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case PAGE_TYPE:
            return payload;
        default:
            return state;
    }
};
var resetKey = function (state, action) {
    if (state === void 0) { state = Math.random(); }
    var payload = action.payload, type = action.type;
    switch (type) {
        case RESET_KEY:
            return payload;
        default:
            return state;
    }
};
var announcements = function (state, action) {
    if (state === void 0) { state = []; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case ANNOUNCEMENTS:
            return payload;
        default:
            return state;
    }
};
export var SCOPE_NAME = 'SHARE_DATA';
var SHARE_DATA = combineReducers({
    loading: loading,
    pageType: pageType,
    resetKey: resetKey,
    announcements: announcements,
});
export default SHARE_DATA;
